import Response from "../../../entities/checkout/checkout-response";

export function getCheckoutResponse(data) {
  return new Response(data);
}
